var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvailability({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.22,
    height: 52.087,
    viewBox: "0 0 56.22 52.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_188",
    x: 0,
    y: 0,
    width: 56.22,
    height: 52.087,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fb1b9509f4c85d1cd9e1930eb641e711",
    transform: "translate(-35.371 3.87)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 35.37, -3.87)",
    filter: "url(#Rectangle_188)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188-2",
    "data-name": "Rectangle 188",
    width: 38.22,
    height: 34.087,
    rx: 0.65,
    transform: "translate(9 6)",
    fill: "#eee"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M24.584,11.935,19.317,8.423,14.05,11.935V2.13H24.584Z",
    transform: "translate(44.15)",
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 16.449,
    height: 9.373,
    rx: 1,
    transform: "translate(48.882 22.307)",
    fill: "#fef8e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M21.347,15.979H12.73a1.08,1.08,0,1,1,0-2.161h8.616a1.08,1.08,0,0,1,0,2.161Zm0-3.538H12.73a1.08,1.08,0,0,1,0-2.161h8.616a1.08,1.08,0,0,1,0,2.161Z",
    transform: "translate(40.068 13.864)",
    fill: "#247a3d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailability);
export default __webpack_public_path__ + "static/media/availability.b70e49129c5d67fe635d2e1f824b4172.svg";
export { ForwardRef as ReactComponent };